import {useNativeAuth} from '../modules/auth/native/NativeAuthProvider';

export const useClientLogin = (): string => {
  const {claims} = useNativeAuth();

  return (claims?.preferred_username as string) ?? '';
};
